export enum RecognizeVipCriterion {
  HomeValue = "home_value",
  MaxPlatformFollowers = "max_platform_followers",
  AssistantToPublicFigure = "assistant_to_public_figure",
  InvestorOrWealthManager = "investor_or_wealth_manager",
  IndustryExpert = "industry_expert",
  SeniorExecutive = "senior_executive",
  WidelyKnownFigure = "widely_known_figure",
  Journalist = "journalist",
  RetailBuyer = "retail_buyer",
}
